import { CraColoring, CraColoringType } from "../../map/models/CraColoring";

export namespace DashboardTypes {
  export enum ItemType {
    MiniMap = "MiniMap",
    PieChartCraColoring = "PieChartCraColoring",
    PieChartFullScore = "PieChartFullScore",
    TableTreatmentSuggestionCounter = "TableTreatmentSuggestionCounter",
    TableDistancePerAttributeValue = "TableDistancePerAttributeValue"

  }

  export interface Item {
    type: ItemType;
    name: string | null;
    colSpan: number | null;
  }

  export interface PieChartCraColoring extends Item {
    type: ItemType.PieChartCraColoring;
    craColoring: CraColoring;
  }

  export interface CreateDashboardRequest {
    projectId: string;
    name: string;
    items: DashboardTypes.Item[];
  }

  export interface UpdateDashboardRequest {
    name: string;
    items: DashboardTypes.Item[];
  }

  export interface Dashboard {
    id: string;
    projectId: string;
    name: string;
    items: DashboardTypes.Item[];
    createdAt: string;
    createdById: string;
  }

  export const getDefaultItemByType = (type: ItemType) => {
    const baseItem: DashboardTypes.Item = {
      type,
      name: null,
      colSpan: null,
    };
    switch (type) {
      case ItemType.PieChartCraColoring:
        return {
          ...baseItem,
          craColoring: {
            type: CraColoringType.Score,
            scoreKey: "global",
          },
        } as DashboardTypes.PieChartCraColoring;
      default:
        return baseItem;
    }
  };
}
